import { render, staticRenderFns } from "./editClient.vue?vue&type=template&id=8874217c&scoped=true&"
import script from "./editClient.vue?vue&type=script&lang=js&"
export * from "./editClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8874217c",
  null
  
)

export default component.exports